export const DATA_CY_AUTH_MORE_OPTIONS = "auth-more-options";
export const DATA_CY_AUTH_USERNAME = "auth-username";
export const DATA_CY_AUTH_PASSWORD = "auth-password";
export const DATA_CY_AUTH_SUBMIT = "auth-submit";
export const DATA_CY_AUTH_ERROR = "auth-error";
export const DATA_CY_OLD_PASSWORD = "old-password";
export const DATA_CY_OLD_PASSWORD_ERROR = "old-password-error";
export const DATA_CY_PASSWORD1 = "password";
export const DATA_CY_PASSWORD2 = "password2";
export const DATA_CY_SUBMIT_PASSWORD = "submit-change-password";
export const DATA_CY_CHANGED_SUCCESS = "password-update-text";
export const DATA_CY_LOGOUT_TEXT = "logout-text";
export const DATA_CY_SIGN_IN_AGAIN = "sign-in-again";
export const DATA_CY_PASSWORD2_ERROR = "password2-error";
